module.exports = __webpack_public_path__ + "static/media/296291.d7410a2d.png";